<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Family Generations</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateFamilyGeneration()">
        <mat-icon>add</mat-icon>
        Add Family Generation
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="familyGenerations()"
      [enableMatching]="false"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditFamilyGeneration($event)"
      (deleteClick)="onDeleteFamilyGeneration($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
